import { ArticleHeading1 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface IPromos {
  Promos?: React.ComponentType;
  Banner: React.ComponentType;
  newbuildingName: string;
  withHeader?: boolean;
  withBorder?: boolean;
}

export const NewbuildingPromos = (props: React.PropsWithChildren<IPromos>) => {
  const { Promos, Banner, newbuildingName, withHeader = true, withBorder = true } = props;

  return (
    <div className={cn(styles['background'], withBorder && styles['background_border'])}>
      {withHeader && (
        <div className={styles['title']}>
          <ArticleHeading1 as="h2">Акции в ЖК {newbuildingName}</ArticleHeading1>
        </div>
      )}
      <Banner />
      {Promos && <Promos />}
    </div>
  );
};
